import React from 'react';
import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import { useImpressionRef, useTrackableLink } from '@noths/polaris-client-react-hooks';
import {
  appStoreURL,
  googlePlayURL,
  IconAppStore,
  IconGooglePlay,
} from '@noths/polaris-client-ribbons-design-system';
import { Button } from '@noths/polaris-design-system-core-components';

import * as styles from './FooterAppPromo.styles';
import { FooterPromo } from 'client-site-chrome-ui/components/molecules/FooterPromo/FooterPromo';

const appPromoImpression = (appStore: string) => {
  sendGAEvent({
    event: 'custom_event',
    event_action: 'App download impression',
    event_category: 'Footer',
    event_label: appStore,
  });
};

const aboutAppsUrl = 'https://www.notonthehighstreet.com/about/apps';

const getTrackingEvent = (label: string, destinationUrl: string) => ({
  event: 'custom_event',
  event_action: 'App download click',
  event_category: 'Footer',
  event_label: label,
  destination_URL: destinationUrl,
});

export const FooterAppPromo = () => {
  const appPromoDesktop = useImpressionRef<HTMLDivElement>(() =>
    appPromoImpression('find out more'),
  );
  const appPromoApple = useImpressionRef<HTMLDivElement>(() => appPromoImpression('apple'));
  const appPromoAndroid = useImpressionRef<HTMLDivElement>(() => appPromoImpression('android'));
  const aboutAppsTrackingEvent = getTrackingEvent('find out more', aboutAppsUrl);
  const appStoreTrackingEvent = getTrackingEvent('apple', appStoreURL);
  const androidTrackingEvent = getTrackingEvent('android', googlePlayURL);
  const { trackLinkClick, trackLinkMouseDown } = useTrackableLink();

  return (
    <FooterPromo intro="Discover the easiest way to shop" title="Get the app">
      <div css={styles.button} ref={appPromoDesktop}>
        <Button
          aria-label="Learn more about our shopping app"
          compact
          href={aboutAppsUrl}
          onClick={(e) => {
            trackLinkClick(aboutAppsTrackingEvent)(e as React.MouseEvent<HTMLAnchorElement>);
          }}
          secondary
        >
          Learn more
        </Button>
      </div>
      <div css={styles.mobileButtons}>
        <div ref={appPromoApple}>
          <a
            css={styles.link}
            href={appStoreURL}
            onClick={trackLinkClick(appStoreTrackingEvent)}
            onMouseDown={trackLinkMouseDown(appStoreTrackingEvent)}
            title="App Store"
          >
            <IconAppStore height="40" width="121" />
          </a>
        </div>
        <div ref={appPromoAndroid}>
          <a
            css={styles.link}
            href={googlePlayURL}
            onClick={trackLinkClick(androidTrackingEvent)}
            onMouseDown={trackLinkMouseDown(androidTrackingEvent)}
            title="Google Play"
          >
            <IconGooglePlay height="40" width="135" />
          </a>
        </div>
      </div>
    </FooterPromo>
  );
};
